export default __webpack_public_path__ + "static/media/up2.4cf34d55.svg";